<script setup>
/* eslint-disable */
import { useCompetitionsStore } from '@/stores/competitions';
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useLaternaStore } from '@/stores/laterna';
import { useDragScroll } from '@/composables/useDragScroll'

const competitionsStore = useCompetitionsStore();
const laternaStore = useLaternaStore();

const router = useRouter();

const props = defineProps({
	section: {
		type: Object,
		required: true,
	},
})

const slider = ref(null)
useDragScroll(slider, {
    speed: 1.5
})


const games = ref([]);

onMounted(() => {
    useCompetitionsStore().fetchTopCompetitions();
})

const goToCompetition = (competition) => {
	router.push({ name: 'pre-sports-competition', params: { sport_id: competition.sport_id, region_id: competition.region_id, competition_id: competition.id } } )
}

</script>
<template>
<div class="container-sm">
    <div class="popular-games-bar">
        <div class="popular-left">
            <img v-if="props.section.media" :src="props.section.media?.path" class="popular-icon"/>
            <span class="popular-title">{{ section.title }}</span>
        </div>
    </div>
    <div ref="slider" class="competitions-scroll">
        <div v-for="(competition, index) in competitionsStore.topCompetitions" :key="index" @click="goToCompetition(competition)" class="competition-card">
            <div class="competition-flag">
                <img :src="'/assets/' + competition.region_icon">
            </div>

            <div class="text">
                <div class="title">{{ competition.name }}</div>
                <div class="subtitle">{{ competition.region_name }}</div>
            </div>
        </div>
    </div>

</div>
</template>

<style scoped>
.popular-left {
    padding-bottom: 5px;
}

.popular-right {
    padding-bottom: 5px;
}

.popular-games-bar {
	/* padding-left: 5px; */
    /* padding-right: 5px; */
	display: flex;
	align-items: center;
	justify-content: space-between;
    border-bottom: 1px solid var(--secondary);
	color: var(--white);
}

.popular-left img {
    width: 40px;
}

.popular-left {
	display: flex;
	align-items: center;
	gap: 10px;
}

.popular-title {
	font-size: 20px;
	font-weight: 600;
	letter-spacing: 0.2px;
}


.container-sm {
    padding-top: 10px;
    padding-bottom: 10px;
}
.competition-flag {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
}

.competition-flag img {
    width: 18px;
    height: 28px;

    object-fit: cover;

    object-position: center;
}

.popular-competitions {
    /* padding: 16px; */
}

.header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
}

.header h2 {
    font-size: 22px;
    font-weight: 600;
    color: var(--white);
}

.star {
    font-size: 18px;
}

.competitions-scroll {
    display: flex;
    gap: 12px;
    overflow-x: auto;
    padding-bottom: 8px;
    padding-top: 10px;
}

.competitions-scroll::-webkit-scrollbar {
    height: 4px;
}

.competitions-scroll::-webkit-scrollbar-track {
    background: transparent;
}

.competitions-scroll::-webkit-scrollbar-thumb {
    background: #3a4450;
    border-radius: 2px;
}

.competition-card {
    display: flex;
    align-items: center;
    gap: 10px;
    background: var(--light-dark);;
    border-radius: 10px;
    padding: 10px 14px;
    min-width: 242px;
    flex-shrink: 0;
    cursor: pointer;
    transition: background 0.2s ease;
}

.competition-card:hover {
    background: #f2f2f2;

}


.competition-card .text {
    display: flex;
    flex-direction: column;
}

.competition-card .title {
    font-size: 16px;
    font-weight: 600;
    color: var(--white);
    line-height: 1.2;
}

.competition-card:hover .title,
.competition-card:hover .subtitle {
   color: #0C131A !important;
}
.competition-card .subtitle {
    font-size: 14px;
    color: #a0a7b1;
}

@media (max-width: 768px) {
    .header h2 {
        font-size: 16px;
        /* justify-content: center; */
    }

    .competition-card {
        min-width: 182px;
        padding: 5px 10px;
    }
.competition-card .title {
    font-size: 14px;
    font-weight: 600;
    color: var(--white);
    line-height: 1.2;
}

.competition-card .subtitle {
    font-size: 13px;
    font-weight: 600;
    color: var(--white);
    line-height: 1.2;
}


     .popular-left img {
        width: 25px;
    }


.popular-left {

	gap: 3px;
}
}
</style>